export const GITHUB = `https://github.com/chuckkanoy`;
export const LINKEDIN = `https://www.linkedin.com/in/charles-k-a7089a123/`;